var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var container = $('.carousel--gallery');
var counter   = 'slider__counter';

$(container).each(function() {
    $(this).parent().append('<span class="'+counter+'"></span>');

    $(this).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;

        if (slick.slideCount > 1) {
            $(event.target).parent().find('.'+counter).html(i + '/' + slick.slideCount);
        }
    });
});

module.exports = function() { /* Nothing to Export */ };
